import { MutualFundDataPage } from "@component/MutualFund/Datapage/MutualFundDataPage";
import type { ReactNode } from "react";
import React from "react";

interface Props {
	isin: string;
}

/**
 * @Routing
 *
 * @title "Befektetési alap - Adatlap"
 * @description "Befektetési alap adatlap"
 * @route "/megtakaritasok/befektetesi-alap/:isin/:name/"
 * @template "view/page/datapage.php"
 * @noIndex "true"
 */
export default class Landing extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { isin } = this.props;

		return <MutualFundDataPage isin={isin} />;
	}
}
